export const selectUser = (state) => state.auth.user;
export const selectUserExam = (state) => state.auth.user.exams;
